<page-content [fullPageWidth]="true" cdkDropListGroup>
  <header-elitment header [hasSideMenu]="true"></header-elitment>
  <side-menu *ngIf="!isEditModeOn && !isMobileDisplay" left-menu>
    <athlete-side-menu></athlete-side-menu>
  </side-menu>
  <sessions-sessions-list-side-menu *ngIf="isEditModeOn && !isMobileDisplay && !is401 && !is404"
                                    left-menu
                                    [organization]="organization"
                                    [library]="library"
  >
  </sessions-sessions-list-side-menu>
  <error-401 *ngIf="is401"></error-401>
  <error-404 *ngIf="is404"></error-404>
  <!--  if mobile-->
  <!--  // if desktop-->
  <mobile-diary-list-content *ngIf="isMobileDisplay" [fromCoachView]="true" [coachViewAgenda]="agendaRow?.agenda!"> </mobile-diary-list-content>
  <module-content *ngIf="!is401 && !is404 && !isMobileDisplay">
    <div fxLayout="row" fxLayoutAlign="space-between start">
      <div fxFill>
        <div class="box">
          <div class="box-content">
            <button *ngIf="!isLoading && annualPlan && weeks"
                    mat-mini-fab
                    color="none"
                    class="more-button float-right mr-50"
                    [matTooltip]="'AnnualPlan' | translate"
                    [routerLink]="'/' + this.organization!.code + '/athletes/' + athleteUser?.id + '/plans/' + annualPlan.id">
              <mat-icon color="primary">zoom_in</mat-icon>
            </button>

            <button *ngIf="!isLoading"
                    mat-mini-fab
                    color="none"
                    class="more-button float-right"
                    [matTooltip]="'AnnualPlanList' | translate"
                    [routerLink]="'/' + organization?.code + '/athletes/' + athleteUser?.id + '/plans'">
              <mat-icon color="primary">link</mat-icon>
            </button>

            <app-annual-plan-graph *ngIf="!isLoading"
                                   [organization]="organization"
                                   [annualPlan]="annualPlan"
                                   [weeks]="weeks"
                                   [showMonths]="true"
                                   [annualPlanPhases]="annualPlanPhases"
                                   [annualPlanMacroCycles]="annualPlanMacroCycles"
                                   viewMode="small"
            ></app-annual-plan-graph>
          </div>
        </div>
      </div>
    </div>
    <div class="calendar-box">
      <nav id="secondary-nav" *ngIf="!isEditModeOn">
        <ul>
          <li>
            <button *ngIf="!isLoading && !is401 && !is404 && agendaRow?.rights?.edit"
                    mat-mini-fab
                    color="none"
                    [matTooltip]="'AgendaExport' | translate"
                    (click)="sessionExport()">
              <i class="material-icons">
                how_to_reg
              </i>
            </button>
          </li>
        </ul>
      </nav>
      <agendas-calendar *ngIf="!isLoading"
                        [organization]="organization"
                        [athleteUser]="athleteUser"
                        [isEditable]="isEditModeOn && !isDataLoading"
                        [agenda]="agendaRow?.agenda!"
                        [timeSegments]="timeSegments"
                        [data]="data"
                        [collapseBefore]="collapseBefore"
                        [collapseAfter]="collapseAfter"
                        [availableTime]="(annualPlan ? annualPlan.weeklyWorkingTime : 0) ?? 0"
                        [availableIntensity]="(currentAnnualPlanWeek ? currentAnnualPlanWeek.intensityPercent : 0) ?? 0"
                        [availableTimePercent]="currentAnnualPlanWeek ? (currentAnnualPlanWeek.sportPercent??0) + (currentAnnualPlanWeek.physicalPercent??0) : 0"
                        [beforeDateChangeHook$]="canChangeDate$.bind(this)"
                        [currentDate]="currentDate"
                        [isDuplicateModActive]="isDuplicateModActive"
                        [timeslotRowsSelectedForDuplication]="timeslotRowsToDuplicate"
                        (isDuplicateModActiveChange)="onDuplicateModeClicked($event)"
                        (onSessionDuplicateCheckboxSelectedChange)="onTimeslotRowDuplicateCheckboxSelected($event)"
                        (onSegmentChanged)="onSegmentChanged($event)"
                        (onCreateNewSession)="onCreateNewSessionFromChild($event)"
                        (onSessionExport)="sessionExport($event)"
                        (currentDateChange)="onRefreshClicked()"
                        (onRefresh)="onRefreshClicked()">
      </agendas-calendar>
    </div>
    <div class="agenda-week-comment">
      <h4>{{ 'title.week_comment' | translate }}</h4>
      <div *ngIf="!isEditModeOn && !is401 && !is404" class="formatext">{{ currentAgendaComment ? currentAgendaComment.comment : '-' }}</div>

      <form [formGroup]="agendaCom" *ngIf="isEditModeOn">
        <fieldset [disabled]="isSaveLoading">
          <mat-form-field [floatLabel]="'auto'">
                              <textarea
                                matInput
                                cdkTextareaAutosize
                                formControlName="comment"
                                maxlength="{{ COMMENT_MAX_LENGTH }}"
                                #commentInput
                                (change)="onChangeComment()"
                              ></textarea>
            <mat-hint align="end">{{ commentInput.value.length }} / {{ COMMENT_MAX_LENGTH }}</mat-hint>
            <mat-error *ngIf="f['comment'].errors">{{ 'validator.comment.max_length' | translate }}</mat-error>
          </mat-form-field>
        </fieldset>
      </form>
    </div>
  </module-content>
  <ng-container *ngIf="!isMobileDisplay">
    <main-action *ngIf="!isEditModeOn && !isLoading && !is401 && !is404 && agendaRow?.rights?.edit"
                 [title]="'Edit_week' | translate"
                 [disabled]="isRefreshLoading"
                 [icon]="'edit'"
                 (onAction)="onEditClicked()">
    </main-action>
    <main-action [title]="isDuplicateModActive ? 'Close_duplicate_mode' : 'Close_edit_mode'"
                 [icon]="'close'"
                 [color]="'none'"
                 [disabled]="isLoading || isRefreshLoading || isSaveLoading"
                 [right]="32"
                 [bottom]="88"
                 (onAction)="onCancelClicked()">
    </main-action>
    <main-action *ngIf="isDuplicateModActive"
                  [title]="'Duplicate'"
                 [icon]="'check'"
                 [isLoading]="isSaveLoading"
                 [disabled]="isLoading || isRefreshLoading || !agendaRow?.rights?.edit || (isDuplicateModActive && !timeslotRowsToDuplicate.length)"
                 (onAction)="onSaveClicked()">
    </main-action>
    <main-action *ngIf="!isDuplicateModActive"
                 [disabled]="isSaveLoading || isLoading"
                 [title]="'Refresh' | translate"
                 [icon]="'refresh'"
                 [isLoading]="isRefreshLoading"
                 [color]="'none'"
                 [bottom]="16"
                 (onAction)="onRefreshClicked()">
    </main-action>
  </ng-container>
</page-content>
